(function () {
  const Core = window.RB.Core;
  const AX = window.RB.AnimKit;
  const { DUR, STAG, TOKEN_FLAVOR, Anim, LATER_WHEN, BLAST_AT, BLAST_SETTLE } = AX;

  const HELD_KINDS = { pay: 1, choose: 1, assign: 1 };
  function heldItem(state) {
    if (!state || !state.chain || !state.chain.length) return null;
    const top = state.chain[state.chain.length - 1];
    if (top.status !== "pending" || top.fromZone !== "hand" || !top.iid) return null;
    const o = state.objs[top.iid];
    if (!o || o.zone !== "chain") return null;
    const pd = state.pending;
    if (!pd || pd.player !== top.controller || !HELD_KINDS[pd.kind]) return null;
    return top;
  }

  function diffArrivals(prev, state) {
    const out = { hand: [[], []], runes: [[], []] };
    if (!prev) return out;
    for (let p = 0; p < 2; p++) {
      const before = {};
      for (const iid of prev.players[p].hand) before[iid] = true;
      for (const iid of state.players[p].hand) {
        if (!before[iid]) out.hand[p].push(iid);
      }
    }
    for (const iid in state.objs) {
      const o = state.objs[iid];
      if (o.zone !== "board") continue;
      const po = prev.objs[iid];
      if (po && po.zone === "board") continue;
      const c = Core.card(state, iid);
      if (c && (c.types || []).indexOf("rune") >= 0) out.runes[o.controller].push(iid);
    }
    out.runes[0].sort();
    out.runes[1].sort();
    return out;
  }

  function zoneAnchorOf(state, iid, controller) {
    const o = iid ? state.objs[iid] : null;
    const owner = o && (o.owner === 0 || o.owner === 1) ? o.owner : controller;
    const zone = o ? o.zone : null;
    if (zone === "trash") return "trash-" + owner;
    if (zone === "banish") return "banish-" + owner;
    if (zone === "deck") return "deck-" + owner;
    if (zone === "hand") return "hand-" + owner;
    if (zone === "board" && o.loc) return locAnchor(o.loc).anchor;
    return null;
  }

  function locAnchor(loc) {
    if (!loc) return { anchor: "table" };
    if (loc.t === "base") return { anchor: "base-" + loc.p };
    return { anchor: "bf-" + loc.iid };
  }

  function pName(state, p) {
    return state.players[p] ? state.players[p].name : "?";
  }

  let prevStateForLookup = null;

  function cardOf(state, iid) {
    if (!iid) return null;
    const c = Core.card(state, iid);
    if (c) return c;
    return prevStateForLookup ? Core.card(prevStateForLookup, iid) : null;
  }

  function runeDomain(card) {
    if (!card) return null;
    const d = card.domains || card.domain;
    if (Array.isArray(d)) return d[0] || null;
    return d || null;
  }

  function translate(action, events, state, opts, arrivals) {
    const steps = [];
    const push = function (s) { steps.push(s); };
    const aiActor = !!opts.aiActor;
    prevStateForLookup = opts.prevState || null;
    const p = action.player;
    const handQ = [arrivals.hand[0].slice(), arrivals.hand[1].slice()];
    const runeQ = [arrivals.runes[0].slice(), arrivals.runes[1].slice()];
    const showFace = function (pl) {
      if (opts.ai && opts.ai[pl]) return false;
      if (!opts.viewers) return true;
      return opts.viewers.indexOf(pl) >= 0;
    };

    const drawSteps = function (pl, iids, label) {
      if (!iids.length) {
        push({
          kind: "arc", dur: DUR.arc * 0.85, crop: "back",
          from: { anchor: "deck-" + pl },
          to: { anchor: "hand-" + pl, pick: ".card.hcard:last-child, .hback:last-child" },
          text: label,
        });
        return;
      }
      const face = showFace(pl);
      const n = iids.length;
      const stag = n > 4 ? STAG.drawMany : STAG.draw;
      const each = n > 4 ? DUR.arc * 0.82 : DUR.arc;
      const kids = [];
      const hand = state.players[pl].hand;
      for (let i = 0; i < n; i++) {
        const hi = hand.indexOf(iids[i]);
        const backKey = !face && hi >= 0 && hi < 12 ? "@hb-" + pl + "-" + hi : null;
        kids.push({
          kind: "arc", dur: each, delay: i * stag,
          card: face ? cardOf(state, iids[i]) : null,
          crop: face ? "full" : "back",
          flip: face ? "toFace" : null,
          from: { anchor: "deck-" + pl },
          to: face
            ? { iid: iids[i], fallback: "hand-" + pl }
            : { fxkey: backKey, anchor: "hand-" + pl, pick: ".hback:last-child" },
          reveal: backKey ? [iids[i], backKey] : [iids[i]], revealAt: 0.98,
          text: i === 0 ? label : null,
        });
      }
      push({ kind: "group", steps: kids, dur: (n - 1) * stag + each });
    };

    const tuckSteps = function (pl, iids, src, label) {
      if (!iids.length) return;
      const face = showFace(pl);
      const n = iids.length;
      const kids = [];
      for (let i = 0; i < n; i++) {
        const iid = iids[n - 1 - i];
        kids.push({
          kind: "arc", dur: DUR.tuck, delay: i * STAG.tuck,
          card: face ? Core.card(src, iid) : null,
          crop: face ? "full" : "back",
          flip: face ? "toBack" : null,
          from: { rectOf: iid, anchor: "hand-" + pl },
          to: { anchor: "deck-" + pl },
          text: i === 0 ? label : null,
        });
      }
      push({ kind: "group", steps: kids, dur: (n - 1) * STAG.tuck + DUR.tuck });
    };

    if (action.type === "MULLIGAN") {
      const cards = action.cards || [];
      const n = cards.length;
      const src = opts.prevState || state;
      if (!n) {
        push({ kind: "banner", dur: DUR.banner, text: pName(state, p) + " keeps their hand" });
      } else {
        tuckSteps(p, cards, src,
          pName(state, p) + " mulligans " + n + " card" + (n > 1 ? "s" : ""));
        push({ kind: "shuffle", dur: DUR.shuffle, player: p });
        if (handQ[p].length) {
          drawSteps(p, handQ[p].splice(0, handQ[p].length), pName(state, p) + " draws " + n);
        }
      }
    }
    if (aiActor && action.type === "PASS") {
      push({ kind: "banner", dur: DUR.banner * 0.7, text: pName(state, p) + " passes" });
    }
    if (aiActor && action.type === "END_TURN") {
      push({ kind: "banner", dur: DUR.banner * 0.8, text: pName(state, p) + " ends the turn" });
    }
    if (aiActor && action.type === "STANDARD_MOVE") {
      const names = (action.units || []).map(function (u) { return Core.name(state, u); }).join(", ");
      push({ kind: "banner", dur: DUR.banner * 0.7, text: pName(state, p) + " moves " + names });
    }

    const diedIids = {};
    const goneTo = {};
    for (const ev of events) {
      if (ev.type === "dies" && ev.snapshot && ev.snapshot.iid) {
        diedIids[ev.snapshot.iid] = true;
        const own = ev.snapshot.owner === 0 || ev.snapshot.owner === 1 ? ev.snapshot.owner : ev.snapshot.controller;
        if (own === 0 || own === 1) goneTo[ev.snapshot.iid] = "trash-" + own;
      } else if (ev.type === "banished" && ev.fromIid && (ev.player === 0 || ev.player === 1)) {
        goneTo[ev.fromIid] = "banish-" + ev.player;
      }
    }
    const exhaustQ = [];
    const cardDomain = function (c) {
      if (!c) return null;
      const d = c.domains || c.domain;
      const first = Array.isArray(d) ? d[0] : d;
      return first && first !== "colorless" ? first : null;
    };
    const heldNow = heldItem(state);
    const heldBefore = heldItem(opts.prevState);
    const chainedNow = function (id) {
      return state.chain.some(function (it) { return it.id === id; });
    };
    const resolvesNow = function (id) {
      return events.some(function (ev) { return ev.type === "resolving" && ev.id === id; });
    };
    const chainStep = function (ev, c) {
      const hold = ev.link > 1;
      return {
        kind: "chain", dur: hold ? 980 : 770, card: c, crop: "full",
        domain: cardDomain(c), hold: hold, link: ev.link,
        from: { prevOf: ev.iid, rectOf: ev.iid, anchor: "hand-" + ev.controller, fallback: "base-" + ev.controller },
        to: { anchor: "chain-" + ev.id, fallback: "table" },
        reveal: ["@chain-" + ev.id], revealAt: 0.86,
        text: ev.label,
        sub: pName(state, ev.controller) + (ev.respondsTo ? " — answering " + ev.respondsTo : ""),
      };
    };
    const skipChainIds = {};
    if (heldNow) skipChainIds[heldNow.id] = true;
    if (heldBefore && !(heldNow && heldNow.id === heldBefore.id) && chainedNow(heldBefore.id) && !resolvesNow(heldBefore.id)) {
      const link = state.chain.findIndex(function (it) { return it.id === heldBefore.id; }) + 1;
      const below = link > 1 ? state.chain[link - 2] : null;
      push(chainStep({
        id: heldBefore.id, iid: heldBefore.iid, controller: heldBefore.controller, label: heldBefore.label,
        link: link, respondsTo: below ? below.label : null,
      }, cardOf(state, heldBefore.iid)));
    }

    const recycledRunes = {};
    for (const ev of events) if (ev.type === "recycleRune") recycledRunes[ev.iid] = true;
    const flushExhaust = function () {
      const iids = exhaustQ.filter(function (iid) { return !recycledRunes[iid]; });
      exhaustQ.length = 0;
      if (!iids.length) return;
      push({ kind: "exhaust", dur: 200 + iids.length * 60, iids: iids });
    };
    const isViewer = function (pl) {
      if (opts.ai && opts.ai[pl]) return false;
      if (!opts.viewers) return true;
      return opts.viewers.indexOf(pl) >= 0;
    };
    const readiedFor = function (pl) {
      const prev = opts.prevState;
      const out = [];
      if (!prev) return out;
      for (const iid in state.objs) {
        const o = state.objs[iid];
        if (o.zone !== "board" || o.controller !== pl || !o.ready) continue;
        const po = prev.objs[iid];
        if (po && po.zone === "board" && !po.ready) out.push(iid);
      }
      return out;
    };
    const attackerFor = function (ev) {
      if (!ev.bf || ev.by === undefined || ev.by === null) return null;
      const units = Core.unitsAt(state, { t: "bf", iid: ev.bf }, function (o) { return o.controller === ev.by; });
      let best = null, bestM = -1;
      for (const u of units) {
        const m = Core.effMight(state, u);
        if (m > bestM) { bestM = m; best = u; }
      }
      return best;
    };

    const rehung = {};
    for (let i = 0; i < events.length - 1; i++) {
      if (events[i].type !== "detached") continue;
      for (let j = i + 1; j < events.length; j++) {
        if (events[j].type === "attached" && events[j].iid === events[i].iid) { rehung[i] = true; break; }
        if (events[j].type !== "detached") break;
      }
    }

    const attachedInBatch = {};
    for (const ev of events) if (ev.type === "attached") attachedInBatch[ev.iid] = true;

    const moveBatch = {};
    const moveSkip = {};
    for (let mi = 0; mi < events.length; mi++) {
      if (events[mi].type !== "move" || moveSkip[mi] || attachedInBatch[events[mi].iid]) continue;
      const grp = [mi];
      for (let mj = mi + 1; mj < events.length && events[mj].type === "move"; mj++) {
        if (attachedInBatch[events[mj].iid]) break;
        if (locAnchor(events[mj].to).anchor !== locAnchor(events[mi].to).anchor) break;
        grp.push(mj);
        moveSkip[mj] = true;
      }
      if (grp.length > 1) moveBatch[mi] = grp;
    }

    let burnsLeft = 0;
    for (const ev of events) if (ev.type === "burned") burnsLeft++;
    const burnMany = burnsLeft > 1;
    const burnKids = [];
    let burnIdx = 0;

    for (let evIdx = 0; evIdx < events.length; evIdx++) {
      const ev = events[evIdx];
      if (ev.type === "detached" && rehung[evIdx]) continue;
      if (ev.type === "move" && (moveSkip[evIdx] || attachedInBatch[ev.iid])) continue;
      if (ev.type === "played" && !ev.token && attachedInBatch[ev.iid]) continue;
      if (ev.type !== "runeExhausted") flushExhaust();
      switch (ev.type) {
        case "beginningPhase": {
          if (isViewer(ev.player)) {
            push({ kind: "band", dur: DUR.banner, text: "YOUR TURN", cls: "gold" });
          } else {
            push({
              kind: "banner", dur: DUR.banner * 0.8,
              text: "TURN " + state.turn.num + " — " + pName(state, ev.player).toUpperCase(),
            });
          }
          const readied = readiedFor(ev.player);
          if (readied.length) push({ kind: "ready", dur: 220 + readied.length * 50, iids: readied });
          break;
        }
        case "mainPhase":
          push({ kind: "ribbon", dur: 240 });
          break;
        case "runeExhausted":
          exhaustQ.push(ev.iid);
          break;
        case "chained": {
          if (skipChainIds[ev.id]) break;
          const srcIid = ev.iid || ev.source || (ev.snapshot ? ev.snapshot.iid : null);
          const c = (srcIid ? cardOf(state, srcIid) : null) ||
            (ev.cardId ? RB.Setup.findCard(ev.cardId) : null);
          const zoneAnchor = ev.snapshot && ev.snapshot.loc ? locAnchor(ev.snapshot.loc).anchor : zoneAnchorOf(state, srcIid, ev.controller);
          const gone = (ev.snapshot && zoneAnchor) ||
            goneTo[ev.snapshot ? ev.snapshot.iid : null] || ("trash-" + ev.controller);
          const hold = ev.link > 1;
          push({
            kind: "chain", dur: hold ? 980 : 770, card: c, crop: "full",
            domain: cardDomain(c), hold: hold, link: ev.link,
            from: ev.iid
              ? { prevOf: ev.iid, anchor: ev.fromZone === "trash" ? "trash-" + ev.controller : ev.fromZone === "hand" ? "hand-" + ev.controller : zoneAnchor || "hand-" + ev.controller, fallback: "base-" + ev.controller }
              : ev.source
                ? { iid: ev.source, anchor: zoneAnchorOf(state, ev.source, ev.controller), fallback: "base-" + ev.controller }
                : { anchor: gone, fallback: gone },
            to: { anchor: "chain-" + ev.id, fallback: "table" },
            reveal: ["@chain-" + ev.id], revealAt: 0.86,
            text: ev.label,
            sub: pName(state, ev.controller) + (ev.respondsTo ? " — answering " + ev.respondsTo : ""),
          });
          break;
        }
        case "resolving": {
          const srcIid = ev.iid || ev.source || (ev.snapshot ? ev.snapshot.iid : null);
          const snapAnchor = ev.snapshot && ev.snapshot.loc ? locAnchor(ev.snapshot.loc).anchor : null;
          const c = (srcIid ? cardOf(state, srcIid) : null) ||
            (ev.cardId ? RB.Setup.findCard(ev.cardId) : null);
          const fromChain = !!Anim._prev["@chain-" + ev.id];
          if (!fromChain && ev.kind === "permanent") break;
          push({
            kind: "resolve", dur: 700, card: c, crop: "full", domain: cardDomain(c),
            from: fromChain ? { prevOf: "@chain-" + ev.id, fallback: "table" }
              : { prevOf: srcIid, rectOf: srcIid, anchor: snapAnchor || zoneAnchorOf(state, srcIid, ev.controller) || "hand-" + ev.controller, fallback: "table" },
            text: ev.label, sub: pName(state, ev.controller) + (ev.left > 1 ? " · " + (ev.left - 1) + " left on the chain" : ""),
          });
          break;
        }
        case "chainResolved": {
          const retireIid = ev.iid || ev.source;
          const retireCard = (retireIid ? cardOf(state, retireIid) : null) ||
            (ev.cardId ? RB.Setup.findCard(ev.cardId) : null);
          if (ev.kind === "spell" && ev.iid) {
            const o = state.objs[ev.iid];
            const zone = o ? o.zone : "trash";
            push({
              kind: "retire", dur: 210, card: retireCard, crop: "full",
              to: { anchor: (zone === "banish" ? "banish-" : "trash-") + ev.controller, fallback: "base-" + ev.controller },
            });
          } else {
            push({ kind: "retire", dur: 110, card: retireCard, crop: "full", to: null });
          }
          break;
        }
        case "finalizedCard":
          break;
        case "played": {
          const c = cardOf(state, ev.iid);
          if (ev.token) {
            const o = state.objs[ev.iid] || {};
            push({
              kind: "spawn", dur: DUR.spawn, card: c, crop: "full",
              flavor: TOKEN_FLAVOR[o.token && o.token.name] || "token",
              to: { iid: ev.iid, fallback: locAnchor(ev.loc).anchor },
              reveal: [ev.iid], revealAt: 0.9,
              text: pName(state, ev.player) + " creates " + (c ? c.name : "a token"),
            });
            break;
          }
          const cine = RB.cinematicFor ? RB.cinematicFor(c) : null;
          if (cine && !Anim.flat()) push({ kind: "cine", dur: cine.dur, card: c, cine: cine });
          push({
            kind: "arc", dur: DUR.arc * 0.85, card: c, crop: "full",
            from: { prevOf: ev.iid, rectOf: ev.iid, anchor: "hand-" + ev.player, fallback: "base-" + ev.player },
            to: { iid: ev.iid, fallback: locAnchor(ev.loc).anchor },
            reveal: [ev.iid],
            text: pName(state, ev.player) + " plays " + (c ? c.name : "a card") +
              (ev.loc && ev.loc.t === "bf" ? " at " + Core.name(state, ev.loc.iid) : ""),
          });
          break;
        }
        case "move": {
          const batch = moveBatch[evIdx] || [evIdx];
          const moveDur = DUR.arc * 0.85;
          const destName = ev.to && ev.to.t === "bf" ? Core.name(state, ev.to.iid) : "base";
          const kids = [];
          let last = 0;
          for (let bi = 0; bi < batch.length; bi++) {
            const mv = events[batch[bi]];
            const mc = cardOf(state, mv.iid);
            const mo = state.objs[mv.iid];
            const riders = (mo && mo.attachments || []).filter(function (a) { return !!cardOf(state, a); });
            const at = bi * STAG.move;
            kids.push({
              kind: "arc", dur: moveDur, card: mc, crop: "full", delay: at,
              from: { prevOf: mv.iid, anchor: locAnchor(mv.from).anchor },
              to: { iid: mv.iid, fallback: locAnchor(mv.to).anchor },
              reveal: [mv.iid], revealAt: 0.98,
              text: bi > 0 ? null : batch.length > 1
                ? batch.length + " units → " + destName
                : (mc ? mc.name : "A unit") + " → " + destName,
            });
            last = Math.max(last, at);
            for (let ri = 0; ri < riders.length; ri++) {
              const rat = at + 40 + ri * 30;
              kids.push({
                kind: "arc", dur: moveDur, card: cardOf(state, riders[ri]), crop: "full", delay: rat,
                from: { prevOf: riders[ri], anchor: locAnchor(mv.from).anchor },
                to: { iid: riders[ri], fallback: locAnchor(mv.to).anchor },
                reveal: [riders[ri]], revealAt: 0.98,
              });
              last = Math.max(last, rat);
            }
          }
          if (kids.length === 1) push(kids[0]);
          else push({ kind: "group", steps: kids, dur: moveDur + last });
          break;
        }
        case "draw":
          if (!ev.n) break;
          drawSteps(ev.player, handQ[ev.player].splice(0, ev.n || 1),
            pName(state, ev.player) + " draws " + (ev.n || 1));
          break;
        case "banished": {
          const bc = cardOf(state, ev.iid);
          const zoneFrom = ev.fromZone === "hand" ? "hand-" : ev.fromZone === "trash" ? "trash-" : ev.fromZone === "deck" ? "deck-" : null;
          const ctl = ev.controller === 0 || ev.controller === 1 ? ev.controller : ev.player;
          push({
            kind: "arc", dur: DUR.arc * 0.75, card: bc,
            crop: ev.fromZone === "hand" && !showFace(ev.player) ? "back" : "full",
            from: { prevOf: ev.fromIid, anchor: ev.from ? locAnchor(ev.from).anchor : zoneFrom ? zoneFrom + ev.player : "base-" + ctl, fallback: "table" },
            to: { anchor: "banish-" + ev.player },
            tickCls: "fxtick-bad",
            text: (bc ? bc.name : "A card") + " is banished",
          });
          break;
        }
        case "toDeck": {
          const dc = cardOf(state, ev.iid);
          push({
            kind: "arc", dur: DUR.arc * 0.85, card: dc, crop: "full",
            from: ev.from ? { prevOf: ev.fromIid, anchor: locAnchor(ev.from).anchor } :
              { prevOf: ev.fromIid, anchor: (ev.fromZone === "trash" ? "trash-" : "hand-") + ev.player },
            to: { anchor: "deck-" + ev.player },
            text: (dc ? dc.name : "A card") + " → " + (ev.bottom ? "bottom" : "top") + " of " + pName(state, ev.player) + "'s deck",
          });
          break;
        }
        case "toHand": {
          const qi = handQ[ev.player].indexOf(ev.iid);
          if (qi >= 0) handQ[ev.player].splice(qi, 1);
          const hc = cardOf(state, ev.iid);
          push({
            kind: "arc", dur: DUR.arc * 0.85, card: hc, crop: "full",
            from: ev.from ? { prevOf: ev.fromIid, anchor: locAnchor(ev.from).anchor } :
              { prevOf: ev.fromIid, anchor: (ev.fromZone === "trash" ? "trash-" : "hand-") + ev.player },
            to: { iid: ev.iid, fallback: "hand-" + ev.player },
            reveal: [ev.iid], revealAt: 0.98,
            text: (hc ? hc.name : "A card") + " returns to hand",
          });
          break;
        }
        case "channel": {
          const n = ev.n || 1;
          const kids = [];
          for (let i = 0; i < n; i++) {
            const rid = runeQ[ev.player].shift();
            const rc = rid ? cardOf(state, rid) : null;
            kids.push({
              kind: "morph", dir: "toRune", dur: DUR.morph, delay: i * STAG.draw,
              card: rc, domain: runeDomain(rc),
              from: { anchor: "runedeck-" + ev.player, fallback: "deck-" + ev.player },
              to: rid ? { iid: rid, fallback: "base-" + ev.player } : { anchor: "base-" + ev.player },
              reveal: rid ? [rid] : [], revealAt: 0.98,
              text: i === 0 ? pName(state, ev.player) + " channels " + n + " rune" + (n > 1 ? "s" : "") : null,
            });
          }
          push({ kind: "group", steps: kids, dur: (n - 1) * STAG.draw + DUR.morph });
          break;
        }
        case "revealCards": {
          const face = ev.private ? showFace(ev.player) : true;
          const cards = (ev.cardIds && ev.cardIds.length
            ? ev.cardIds.map(function (id) { return id ? RB.Setup.findCard(id) : null; })
            : (ev.iids || []).map(function (i2) { return cardOf(state, i2); }));
          if (ev.source === "hand" && cards.length) {
            const faceUp = showFace(ev.player);
            const keys = cards.map(function (_, i) {
              return faceUp ? (ev.iids || [])[i] : "@hb-" + ev.player + "-" + i;
            }).filter(function (k) { return !!k; });
            push({
              kind: "handflip",
              dur: DUR.deal + DUR.revealHold + DUR.collect + cards.length * STAG.deal,
              cards: cards, player: ev.player, flip: !faceUp,
              at: keys.map(function (k) {
                return String(k).charAt(0) === "@"
                  ? { fxkey: k, fallback: "hand-" + ev.player }
                  : { iid: k, fallback: "hand-" + ev.player };
              }),
              reveal: keys, revealAt: 0.97,
              text: pName(state, ev.player) + (ev.private ? " looks at their hand" : " reveals their hand"),
            });
            break;
          }
          push({
            kind: "revealfan",
            dur: DUR.deal + DUR.revealHold + DUR.collect + cards.length * STAG.deal,
            cards: cards, face: face,
            from: { anchor: "deck-" + ev.player },
            text: pName(state, ev.player) + (ev.private ? " looks at " : " reveals ") +
              cards.length + " card" + (cards.length > 1 ? "s" : ""),
          });
          break;
        }
        case "peekFacedown": {
          const cards = (ev.cardIds || []).map(function (id) { return id ? RB.Setup.findCard(id) : null; });
          if (!cards.length) break;
          push({
            kind: "handflip",
            dur: DUR.deal + DUR.revealHold + DUR.collect + cards.length * STAG.deal,
            cards: cards, player: ev.player, flip: true,
            at: (ev.iids || []).map(function (i2) { return { iid: i2, fallback: "hand-" + (1 - ev.player) }; }),
            reveal: ev.iids || [], revealAt: 0.97,
            text: pName(state, ev.player) + " looks at the hidden card" + (cards.length > 1 ? "s" : ""),
          });
          break;
        }
        case "recycledCards": {
          if (action.type === "MULLIGAN") break;
          const kids = [];
          const many = ev.cards.length > 1;
          for (let ri = 0; ri < ev.cards.length; ri++) {
            const entry = ev.cards[ri];
            const rc = entry.card ? RB.Setup.findCard(entry.card) : null;
            const fromZone = entry.fromZone === "hand" ? "hand-" + ev.player
              : entry.fromZone === "trash" ? "trash-" + ev.player
                : entry.fromZone === "deck" ? "deck-" + ev.player : "table";
            kids.push({
              kind: "arc", card: rc, crop: "full", dur: many ? DUR.recycle * 0.8 : DUR.recycle,
              delay: ri * STAG.burn,
              from: { prevOf: entry.iid, rectOf: entry.iid, anchor: fromZone },
              to: { anchor: "deck-" + ev.player },
              tickCls: "fxtick-good",
              text: ri === 0
                ? pName(state, ev.player) + " recycles " + ev.n + " card" + (ev.n > 1 ? "s" : "")
                : null,
            });
          }
          push({ kind: "group", steps: kids, dur: DUR.recycle + (ev.cards.length - 1) * STAG.burn });
          break;
        }
        case "recycleRune": {
          const rc = ev.card ? RB.Setup.findCard(ev.card) : null;
          push({
            kind: "morph", dir: "toCard", dur: DUR.recycle, slotHold: 0.12,
            card: rc, domain: ev.domain || runeDomain(rc),
            from: { prevOf: ev.iid, anchor: "base-" + ev.player },
            to: { anchor: "runedeck-" + ev.player, fallback: "deck-" + ev.player },
            text: pName(state, ev.player) + " recycles a rune",
          });
          break;
        }
        case "takeDamage": {
          const nm = Core.name(state, ev.iid);
          push({
            kind: "pop", dur: DUR.pop, cls: "dmg", text: "−" + ev.amt,
            at: { iid: ev.iid },
            fallbackText: (nm !== "?" ? nm : "A unit") + " takes " + ev.amt,
          });
          if (ev.src === "combat" && ev.bf && !diedIids[ev.iid]) {
            const atk = attackerFor(ev);
            const dom = atk ? cardDomain(cardOf(state, atk)) : null;
            if (atk) push({ kind: "flourish", dur: dom === "fury" ? 300 : dom === "calm" ? 420 : 380, domain: dom || "colorless", at: { iid: ev.iid }, attackerIid: atk });
          }
          if (ev.bonus) {
            push({
              kind: "banner", dur: DUR.banner * 0.8, cls: "gold",
              text: (nm !== "?" ? nm : "Target") + " takes " + ev.amt + " — " + (ev.base || 0) +
                (ev.bonusFrom || []).map(function (b) { return " +" + b.n + " from " + b.name; }).join(""),
            });
          }
          break;
        }
        case "dies": {
          const snap = ev.snapshot || {};
          const nm = snap.name || "A unit";
          const owner = snap.owner !== undefined && snap.owner !== null ? snap.owner : snap.controller;
          const at = locAnchor(snap.loc);
          push({
            kind: "group", dur: DUR.detonate, steps: [
              {
                kind: "detonate", dur: DUR.detonate, slotHold: BLAST_SETTLE, crop: "art",
                card: snap.iid ? cardOf(state, snap.iid) : null,
                from: { prevOf: snap.iid, anchor: at.anchor },
                to: owner === 0 || owner === 1 ? { anchor: "trash-" + owner } : null,
                at: at, fallbackText: nm + " dies",
              },
              {
                kind: "pop", dur: Math.round(DUR.detonate * 0.62), delay: Math.round(DUR.detonate * BLAST_AT),
                cls: "death", text: nm + " dies", at: at, fallbackText: nm + " dies",
              },
            ],
          });
          break;
        }
        case "stunned":
          push({
            kind: "stamp", dur: 240, iid: ev.iid, sel: ".badge.stun", shake: true,
            reveal: ["@stun-" + ev.iid], revealAt: 0,
            fallbackText: Core.name(state, ev.iid) + " is stunned", cls: "stun",
          });
          break;
        case "empowered":
          push({
            kind: "stamp", dur: 240, iid: ev.iid, sel: ".badge.emp", shake: false,
            reveal: ["@emp-" + ev.iid], revealAt: 0,
            fallbackText: Core.name(state, ev.iid) + " is empowered", cls: "gold",
          });
          break;
        case "delayedEffect": {
          const when = LATER_WHEN[ev.on] || ("when " + String(ev.on || "later"));
          const caption = (ev.label || "Delayed effect") + " — " + when;
          if (ev.iid) {
            push({
              kind: "stamp", dur: 260, iid: ev.iid, sel: ".badge.linger", shake: false,
              reveal: ["@linger-" + ev.iid], revealAt: 0,
              fallbackText: caption, cls: "linger",
            });
          }
          push({ kind: "banner", dur: DUR.banner * 0.8, text: pName(state, ev.player) + ": " + caption });
          break;
        }
        case "buffed":
          push({ kind: "buffring", dur: 320, iid: ev.iid, reveal: ["@buff-" + ev.iid], revealAt: 0 });
          break;
        case "conquer":
        case "hold":
          push({
            kind: "banner", dur: DUR.banner, cls: "gold",
            text: pName(state, ev.player) + (ev.type === "conquer" ? " conquers " : " holds ") + Core.name(state, ev.bf) + " — +1 point",
          });
          push({
            kind: "claim", dur: 900, player: ev.player, word: ev.type === "conquer" ? "CONQUERED" : "HELD",
            at: { anchor: "bf-" + ev.bf },
          });
          push({ kind: "score", dur: 600, player: ev.player, n: 1, from: { anchor: "bf-" + ev.bf } });
          break;
        case "scored":
          if (ev.n > 0) {
            push({
              kind: "score", dur: 600, player: ev.player, n: ev.n,
              from: ev.source ? { iid: ev.source, fallback: "table" } : { anchor: ev.reason === "burnout" ? "deck-" + (1 - ev.player) : "table" },
            });
          }
          break;
        case "attached": {
          const c = cardOf(state, ev.iid);
          push({
            kind: "arc", dur: 620, card: c, crop: "full",
            from: { prevOf: ev.iid, rectOf: ev.iid, anchor: "hand-" + ev.player, fallback: "base-" + ev.player },
            to: { iid: ev.iid, fallback: "base-" + ev.player },
            reveal: [ev.iid], revealAt: 0.9,
            text: (c ? c.name : "Gear") + " equips " + Core.name(state, ev.host),
          });
          push({ kind: "mightpop", dur: 260, iid: ev.host });
          break;
        }
        case "detached": {
          const c = cardOf(state, ev.iid);
          push({
            kind: "arc", dur: 480, card: c, crop: "full",
            from: { prevOf: ev.iid, fallback: "base-" + ev.player },
            to: { iid: ev.iid, anchor: "base-" + ev.player },
            reveal: [ev.iid], revealAt: 0.9,
            text: (c ? c.name : "Gear") + " detaches",
          });
          break;
        }
        case "combatStart":
          push({ kind: "banner", big: true, dur: DUR.big, cls: "red", text: "COMBAT — " + Core.name(state, ev.bf).toUpperCase() });
          break;
        case "showdownStart":
          push({ kind: "banner", big: true, dur: DUR.big * 0.85, text: "SHOWDOWN — " + Core.name(state, ev.bf).toUpperCase() });
          break;
        case "combatEnd":
          push({ kind: "banner", dur: DUR.banner * 0.7, text: "Combat at " + Core.name(state, ev.bf) + " ends" });
          break;
        case "recalled":
          push({ kind: "banner", dur: DUR.banner * 0.7, text: Core.name(state, ev.iid) + " is recalled" });
          break;
        case "discarded": {
          const c = cardOf(state, ev.iid);
          push({
            kind: "arc", dur: DUR.arc * 0.75, card: c,
            crop: showFace(ev.player) ? "full" : "back",
            from: { prevOf: ev.iid, rectOf: ev.iid, anchor: "hand-" + ev.player },
            to: { anchor: "trash-" + ev.player },
            tickCls: "fxtick-bad",
            text: pName(state, ev.player) + " discards " + (c ? c.name : "a card"),
          });
          break;
        }
        case "burned": {
          const c = cardOf(state, ev.iid);
          const step = {
            kind: "arc", card: c, crop: "full", flip: "toFace",
            from: { anchor: "deck-" + ev.player },
            to: { anchor: "trash-" + ev.player },
            tickCls: "fxtick-bad",
          };
          if (burnMany) {
            step.dur = DUR.burnFast;
            step.delay = burnIdx * STAG.burn;
            burnKids.push(step);
            if (burnIdx === 0) {
              step.text = pName(state, ev.player) + " burns " + burnsLeft + " cards";
              push({ kind: "group", steps: burnKids, dur: (burnsLeft - 1) * STAG.burn + DUR.burnFast });
            }
          } else {
            step.dur = DUR.burn;
            step.hold = { scale: 1.5, ms: DUR.burnRead };
            step.text = pName(state, ev.player) + " burns " + (c ? c.name : "a card");
            push(step);
          }
          burnIdx++;
          break;
        }
      }
    }
    flushExhaust();
    return steps;
  }

  Object.assign(AX, { diffArrivals: diffArrivals, translate: translate });
  Anim.heldItem = heldItem;
  Anim.translate = translate;
  Anim.diffArrivals = diffArrivals;
})();
